import React from 'react';
import { Alert } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import { isAudioMixPreviewSupported } from '../utils/isAudioMixPreviewSupported';

const InstagramAudioDeviceNotice = () => {
  const { t } = useTranslation();

  if (isAudioMixPreviewSupported()) return null;

  return (
    <Alert variant="info" data-cy="instagram-audio_device-notice">
      {t('instagramAudio.volumeNotPreviewable')}
    </Alert>
  );
};

export default InstagramAudioDeviceNotice;
